import './App.css'
import { useEffect, useState } from 'react'
import { supabase } from './supabase/SupabaseLogin'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import FieldTables from './components/FieldTables'
import FormView from './components/form_view/FormView'
import CBRatio from './components/cbratio/CBRatio';

export default function App() {

  const [fields, setFields] = useState([])

  useEffect(() => {
    let isMounted = true
    async function pullTable() {
      const { data, error } = await supabase.from('sf_fields').select('*')
      // console.log(data)
      // console.log(error)
      isMounted && setFields(data)
    }
    pullTable()
    return () => (isMounted = false)
  }, [])

  return (
    <>
      {
        fields && (
          <BrowserRouter>
              <Routes>
                <Route path='/' element={<FieldTables fields={fields} />}/>
                <Route path='/formview' element={<FormView fields={fields} />} />
                <Route path='/cbratio' element={<CBRatio />} />
              </Routes>
          </BrowserRouter>
        )
      }
    </>
  )
}
